// src/services/marketplaceService.js
import api from './api';

// ── Public (no auth) ──────────────────────────────────────────────────

export const browseShops = (params = {}) =>
  api.get('/marketplace/shops', { params });

export const getShop = (artistId) =>
  api.get(`/marketplace/shop/${artistId}`);

export const browseArt = (params = {}) =>
  api.get('/marketplace/art', { params });

export const getArtDetail = (artId) =>
  api.get(`/marketplace/art/${artId}`);

export const placeOrder = (payload) =>
  api.post('/marketplace/checkout', payload);

export const trackOrder = (token) =>
  api.get('/marketplace/order/track', { params: { token } });

// ── Artist (requires auth) ───────────────────────────────────────────

export const getMyShop = () =>
  api.get('/marketplace/my-shop');

export const updateMyShop = (payload) =>
  api.put('/marketplace/my-shop', payload);

export const createListing = (payload) =>
  api.post('/marketplace/listings', payload);

export const withdrawListing = (artId) =>
  api.put(`/marketplace/listings/${artId}/withdraw`);

export const getMyOrders = (params = {}) =>
  api.get('/marketplace/my-orders', { params });

export const approveOrder = (orderId) =>
  api.put(`/marketplace/orders/${orderId}/approve`);

export const rejectOrder = (orderId) =>
  api.put(`/marketplace/orders/${orderId}/reject`);

export const shipOrder = (orderId) =>
  api.put(`/marketplace/orders/${orderId}/ship`);

export const completeOrder = (orderId) =>
  api.put(`/marketplace/orders/${orderId}/complete`);

export default {
  browseShops,
  getShop,
  browseArt,
  getArtDetail,
  placeOrder,
  trackOrder,
  getMyShop,
  updateMyShop,
  createListing,
  withdrawListing,
  getMyOrders,
  approveOrder,
  rejectOrder,
  shipOrder,
  completeOrder,
};
